import React from "react";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import PlanningFormContainer from "../shared/planningForm/planningFormContainer";
import { Typography, withStyles } from "@material-ui/core";
import { Trans, useTranslations } from "adapters/i18n";
import { BannerAlert } from "features/shared/components";

const PlanningEditPage = ({
  classes,
  planningPlanData,
  periodTitles,
  freeCategories,
  categories,
  formulas,
  planningsTableList,
  planningList,
  onChangeCategory,
  onChangeFormula,
  onChangeHerdCount,
  addNewLine,
  onDeleteLine,
  onChangePlanningInitialDate,
  hasGoalPlanSync,
  isGoalPlanUnsync,
  activeGoalPeriod,
  ingredientsPrices,
  formulasIngredients,
  onChangeIngredientPrice,
  updateIngredientsList,
  onSubmit = () => {},
  goBack = () => {},
  summaryReport,
  updateSummaryReport,
}) => {
  const { t } = useTranslations();
  const SubTitle = ({ hasGoalPlanSync, isGoalPlanUnsync }) => {
    return (
      <div className={classes.subTitle}>
        {hasGoalPlanSync && (
          <BannerAlert type="warning">{t("planning:edit.warning")}</BannerAlert>
        )}
        {isGoalPlanUnsync && (
          <BannerAlert customIcon={<InfoOutlined color="error" />} type="error">
            <span>
              <strong>{t("planning:edit.unsync-title")}</strong>
              <br />
              {t("planning:edit.unsync-desc")}
            </span>
          </BannerAlert>
        )}
        <Typography className={classes.subtitle}>
          <Trans
            i18nKey="planning:edit.form-info"
            components={{
              span: <span className={classes.subTitleHighlight} />,
            }}
          />
        </Typography>
      </div>
    );
  };

  const IngredientSubTitle = () => (
    <Typography className={classes.subtitle}>
      {t("planning:register.ingredient-info")}
    </Typography>
  );

  return (
    <PlanningFormContainer
      title={t("planning:edit.edit-planning")}
      subtitle={
        <SubTitle
          hasGoalPlanSync={hasGoalPlanSync}
          isGoalPlanUnsync={isGoalPlanUnsync}
          initialDate={activeGoalPeriod.initialDate}
          finalDate={activeGoalPeriod.finalDate}
        />
      }
      ingredientsSubtitle={<IngredientSubTitle />}
      ingredientsPrices={ingredientsPrices}
      formulasIngredients={formulasIngredients}
      onChangeIngredientPrice={onChangeIngredientPrice}
      updateIngredientsList={updateIngredientsList}
      planningPlanData={planningPlanData}
      periodTitles={periodTitles}
      freeCategories={freeCategories}
      categories={categories}
      formulas={formulas}
      planningsTableList={planningsTableList}
      planningList={planningList}
      onChangeCategory={onChangeCategory}
      onChangeFormula={onChangeFormula}
      onChangeHerdCount={onChangeHerdCount}
      addNewLine={addNewLine}
      onDeleteLine={onDeleteLine}
      onChangePlanningInitialDate={onChangePlanningInitialDate}
      onSubmit={onSubmit}
      goBack={goBack}
      summaryReport={summaryReport}
      updateSummaryReport={updateSummaryReport}
    />
  );
};

const styles = (theme) => ({
  subTitle: {
    margin: "41px 0 6px 0",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  subTitleHighlight: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
});

export default withStyles(styles)(PlanningEditPage);
